<template>
  <div>
    <WidgetMain
      :survey_id="surveyid"
      :stepid="stepId"
      @close-widget="closeWidget"
      @router-push="routerPush"
    ></WidgetMain>

    <div
      v-if="!loadingStatus"
      class="relative bg-gray-900 hover:bg-gray-800 text-white opacity-70 top:0 sm:top-1 w-full sm:w-max mx-auto h-8 sm:h-auto text-center cursor-pointer text-base px-2 py-1 sm:rounded-md"
      :style="{
        'z-index': 2147483647,
      }"
    >
      <router-link
        :to="{ path: '/builder/' + survey.id }"
        class="flex flex-row justify-center items-center hover:no-underline"
      >
        <div class="px-4 text-base my-auto border-r border-gray-500 mr-1">Close Preview </div> 
        <svg-icon
              icon="heroicons/outline/x"
              class="h-5 w-5"
            />
      </router-link>
    </div>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
//import NavBar from "@/components/Navbar";
import WidgetMain from "@/WidgetMain";
import router from "@/router/route.js";

export default {
  components: { WidgetMain },
  props: ["surveyid"],
  data() {
    return {
      loadingStatus: true,
    };
  },
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("steps", (query) => {
          query
            .orderBy("order", "asc")
            .with("options", (query) => {
              query.orderBy("order", "asc").with("contents", (query) => {
                query.orderBy("order", "asc");
              });
            })
            .with("rows", (query) => {
              query.orderBy("order", "asc").with("columns", (query) => {
                query.orderBy("order", "asc").with("contents", (query) => {
                  query.orderBy("order", "asc");
                });
              });
            });
        })
        .first();
    },
    stepId() {
      return this.$route.params.id || null;
    },
    pixeldata() {
      return {
        email: "test@example.com",
        user_id: "user1234",
        name: "Example User",
        account_id: "XYZX-UNIQLO-3434_MIAMI"
      };
    },
  },
  methods: {
    async init() {
      var id = this.surveyid || null;
      this.$store.commit('SET_CONFIG_VARS', this.pixeldata);

      if (id === null) {
        console.log("Error, survey not found.");
        this.$destroy();
      }

      this.loadingStatus = true;

      //if survey is not already loaded in state, request it from the server
      //if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      //}

      this.loadingStatus = false;
    },
    routerPush(obj) {
      router.push(obj);
    },
    closeWidget() {
      router.push({ path: "/builder/" + this.survey.id });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
a:hover {
  color: inherit; /* Inherits color property from its parent */
}
</style>
